<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/9obJQ3/tc-custom/9781460363256.jpg?1728259292189" alt="This image is the cover for the book Final Exit"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Final Exit
      </h1>
      <p class="bookDescription body article font2">
        <p>TEN YEARS AGO,TRAGEDY TORE THEM APART<br/><br/>But when FBI special agent Carolyn Monahanwalks back into the life of homicide lieutenantConor Rafferty, the sizzle is undeniable. They areback together, albeit reluctantly, to find the serialkiller who is terrorizing Boston.<br/><br/>Caro has made a successful career of puttinghomicidal maniacs behind bars, and Rafferty isa good cop who’s been handed the case of alifetime. Amid bureaucratic red tape and amounting body count, they uncover evidencethat points to a decade-old unsolved homicide.The tension escalates when the killer developsa psychotic preoccupation with Caro herself.<br/><br/>As the pressure builds to solve the murders, sodoes the attraction between Caro and Rafferty.But the question remains: Who will get to Carofirst, the killer or the cop?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laurie Breton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6626f080